import { sampleOrganization, sampleGM } from '@/tumeloshared'
import { OrganizationService } from './OrganizationService'

export const OrganizationServiceMock: OrganizationService = {
  batchGetOrganizations: async (identifiers) => identifiers.map(() => sampleOrganization()),
  listGeneralMeetings: async () => [sampleGM()],
}
